import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { caseTypeLaboratoriesConfigurationServices } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types.service'
import { store } from '@/store/store'
import { ConfigurationCaseTypeLaboratoryResponse } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types.dto'

export const columnsDefTextLocalCaseTypesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.caseTypes'),
            field: 'caseType.description',
            minWidth: 200,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.localName'),
            field: 'description',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.identifier'),
            field: 'serial',
            minWidth: 160,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface LocalCaseTypesGridState extends CrudModelPaginatorLaboratory<ConfigurationCaseTypeLaboratoryResponse> {
    labId: number
}
export const initialLocalCaseTypesGridState =
    (): LocalCaseTypesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.caseTypes.caseType',
        selectedRows: [],
        columnsDef: columnsDefTextLocalCaseTypesGrid(),
        datasource: new PaginatorLaboratoryDatasource(caseTypeLaboratoriesConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
